import { UiSchema } from '@rjsf/utils'

import { calculateLFMeasurementOfMaterial } from '../imup/sagas/2D/createDrawableLocation'
import { FormProperties } from '../imup/types'
import { ActiveDrawable } from '../models/activeDrawable'
import { GeneralDrawableSettings } from '../models/activeDrawableSettings'
import { DRAWABLE_TYPES } from '../shared/constants/drawable-types'
import {
    eaveGableLengthUIOrder,
    eaveGableLengthUiSchema,
} from '../shared/constants/form-schema/eaveGableLength/uiSchema'
import {
    clearSoffitTypeForExposedSoffit,
    eaveGableLengthFormSubmitCleanUp,
} from '../shared/services/form-schema/eave-gable-length/helpers'
import { convertFullNumberFractionToDecimal, truncateToDecimals } from '../utils/formSchema/numberConversion'

const otherValue = 'other'

const uiSchema: UiSchema = {
    ...eaveGableLengthUiSchema('Gable'),

    vented_gable: {
        'ui:title': 'Vented Gable Soffit Panel',
        'ui:field': 'SwitchField',
    },
    pitch: {
        'ui:placeholder': 'Select Pitch',
        'ui:field': 'SectionDivider',
        'ui:options': {
            dropdownWithPlaceholder: true,
            topDividerFieldType: 'dropdown',
        },
    },
    pitch_other: {
        'ui:title': 'Pitch Other',
        'ui:placeholder': 'Pitch Other',
    },

    include_ladder_framing: {
        'ui:field': 'SectionDivider',
        'ui:options': {
            topDividerFieldType: 'switch',
            isLabelBold: true,
        },
    },
    ladder_framing_dimensions: {
        'ui:field': 'LumberDimensionsField',
        'ui:options': {
            topDividerFieldType: 'switch',
        },
    },
    'ui:order': [
        'folder',
        'name',
        'label',
        'selection',
        'include_sub_fascia',
        'sub_fascia_dimensions',
        'include_ladder_framing',
        'ladder_framing_dimensions',

        ...eaveGableLengthUIOrder,
    ],
}

const onValidate = () => {}

const onUpdate = (_, formData) => clearSoffitTypeForExposedSoffit(formData)

/**
 * Augment the drawables of the from based on the new settings
 * @returns
 * @param input
 */
function prepareDrawables(input: {
    drawables: ActiveDrawable[]
    newSettings: GeneralDrawableSettings
    scaleFactor: number
}): ActiveDrawable[] {
    const { drawables, newSettings } = input

    return drawables.map((drawable) => {
        drawable.settings.quantity = calculateLFMeasurementOfMaterial(drawable.settings.linear_total, {
            type: DRAWABLE_TYPES.GABLE_LENGTH,
            settings: newSettings,
        })

        return drawable
    })
}

const onSubmit = (settings, formData) => {
    const newSettings = eaveGableLengthFormSubmitCleanUp({ ...settings, ...formData })

    if (
        newSettings?.robust_rafter_tail &&
        ['dimensional lumber', 'panel (4x8)'].includes(newSettings.soffit_type?.toLowerCase())
    ) {
        newSettings.vented_gable = null
    }

    if (newSettings.pitch === otherValue && newSettings.pitch_other) {
        newSettings.pitch =
            convertFullNumberFractionToDecimal(String(newSettings.pitch_other)) ?? newSettings.pitch_other
        newSettings.pitch = truncateToDecimals(newSettings.pitch)

        delete newSettings.pitch_other
    } else if (newSettings.pitch !== otherValue) {
        newSettings.pitch_other = null
    }

    return newSettings
}

const form: FormProperties = { uiSchema, onValidate, onSubmit, prepareDrawables, onUpdate }

export default form
